class AuthForm extends HTMLElement {
	constructor(){
		super();
		//variables
		this.forgetPassword = this.querySelector('#forgetPassword');
		this.recoverForm = this.querySelector('#recoverForm');
		this.recoverFormButton = this.querySelector('#recoverSubmit');
		this.loginForm = this.querySelector('#CustomerLoginForm');
		this.closeRecover = this.querySelector('#closeRecover');
		this.cancelRecover = this.querySelector('#cancelRecover');
		this.successRecover = this.querySelector('#recoverSubmitSuccess');
		this.authTab = this.querySelector('#auth-tab');
		this.passwordInput = this.querySelector('[type="password"]')
	}

	connectedCallback() {
		this.forgetPassword?.addEventListener('click', this.showRecover.bind(this))
		this.closeRecover?.addEventListener('click', this.hideRecover.bind(this))
		this.cancelRecover?.addEventListener('click', this.hideRecover.bind(this))
	}

	// show recover password hide login and tabs
	showRecover(e){
		e?.preventDefault()
		this.recoverForm.classList.remove('hidden')
		this.authTab.classList.add('hidden')
		this.loginForm.classList.add('hidden')
	}

	// hide recover password form show login and tabs
	hideRecover(e){
		e?.preventDefault()
		this.recoverForm.classList.add('hidden')
		this.loginForm.classList.remove('hidden')
		this.authTab.classList.remove('hidden')
	}
}

customElements.define('auth-form',AuthForm);

class PasswordValidator extends HTMLElement {
	constructor() {
		super()
		this.password = this.querySelector('[type="password"]');
		this.confirmation = this.querySelector('#ConfirmationPassword');
		this.confirmMessage = this.querySelector('#confirmMessage');

		this.helperText = {
			charLength: this.querySelector('.helper-text #length'),
			lowercase: this.querySelector('.helper-text #lowercase'),
			uppercase: this.querySelector('.helper-text #uppercase'),
			special: this.querySelector('.helper-text #special')
		};

		this.pattern = {
			charLength: () => {
				if( this.password.value.length >= 8 ) {
					return true;
				}
			},
			lowercase: () => {
				var regex = /^(?=.*[a-z]).+$/; // Lowercase character pattern

				if( regex.test(this.password.value) ) {
					return true;
				}
			},
			uppercase: () => {
				var regex = /^(?=.*[A-Z]).+$/; // Uppercase character pattern

				if( regex.test(this.password.value) ) {
					return true;
				}
			},
			special: () => {
				var regex = /^(?=.*[0-9_\W]).+$/; // Special character or number pattern

				if( regex.test(this.password.value) ) {
					return true;
				}
			}
		};
	}

	connectedCallback(){
		// Listen for keyup action on password field
		this.password.addEventListener('keyup', () => {

			Object.values(this.helperText).forEach(  item => {
				if(!item.classList.contains('text-success'))
					item.classList.remove( 'hidden')
			})

			// Check that password is a minimum of 8 characters
			this.patternTest( this.pattern.charLength(), this.helperText.charLength );

			// Check that password contains a lowercase letter
			this.patternTest( this.pattern.lowercase(), this.helperText.lowercase );

			// Check that password contains an uppercase letter
			this.patternTest( this.pattern.uppercase(), this.helperText.uppercase );

			// Check that password contains a number or special character
			this.patternTest( this.pattern.special(), this.helperText.special );

			// Check that all requirements are fulfilled
			if( this.hasClass(this.helperText.charLength, 'text-success') &&
				this.hasClass(this.helperText.lowercase, 'text-success') &&
				this.hasClass(this.helperText.uppercase, 'text-success') &&
				this.hasClass(this.helperText.special, 'text-success')
			){
				this.addClass(this.password.parentElement, 'text-success');
			}
			else {
				this.removeClass(this.password.parentElement, 'text-success');
			}
		});

		this.confirmation?.addEventListener( 'input', () => this.confirmPassword() )
	}

	patternTest(pattern, response) {
		if(pattern) {
			this.addClass(response, 'text-success');
			setTimeout(() => this.addClass(response, 'hidden'), 2000)
		}
		else {
			this.removeClass(response, 'text-success');
		}
	}

	addClass(el, className) {
		if (el.classList) {
			el.classList.add(className);
		}
		else {
			el.className += ' ' + className;
		}
	}

	removeClass(el, className) {
		if (el.classList) {
			el.classList.remove(className);
		} else {
			el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	}

	hasClass(el, className) {
		if (el.classList) {
			return el.classList.contains(className);
		}
		else {
			new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
		}
	}

	confirmPassword(){
		if( this.password.value !== this.confirmation.value ){
			this.confirmMessage.classList.add('text-alert')
			this.confirmMessage.classList.remove('text-success')
		}else {
			this.confirmMessage.classList.remove('text-alert')
			this.confirmMessage.classList.add('text-success')
		}
	}
}

customElements.define( 'password-validator', PasswordValidator );
